var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepscheduleicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5505_6216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 2V6",
    stroke: "#00C49A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 2V6",
    stroke: "#00C49A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 9H23",
    stroke: "#00C49A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 4H7C5.895 4 5 4.895 5 6V19C5 20.105 5.895 21 7 21H21C22.105 21 23 20.105 23 19V6C23 4.895 22.105 4 21 4Z",
    stroke: "#00C49A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.01268 12.7285C8.87468 12.7285 8.76268 12.8405 8.76368 12.9785C8.76368 13.1165 8.87568 13.2285 9.01368 13.2285C9.15168 13.2285 9.26368 13.1165 9.26368 12.9785C9.26368 12.8405 9.15168 12.7285 9.01268 12.7285",
    stroke: "#00C49A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0127 12.7285C13.8747 12.7285 13.7627 12.8405 13.7637 12.9785C13.7637 13.1165 13.8757 13.2285 14.0137 13.2285C14.1517 13.2285 14.2637 13.1165 14.2637 12.9785C14.2637 12.8405 14.1517 12.7285 14.0127 12.7285",
    stroke: "#00C49A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0127 12.7285C18.8747 12.7285 18.7627 12.8405 18.7637 12.9785C18.7637 13.1165 18.8757 13.2285 19.0137 13.2285C19.1517 13.2285 19.2637 13.1165 19.2637 12.9785C19.2637 12.8405 19.1517 12.7285 19.0127 12.7285",
    stroke: "#00C49A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.01268 16.7285C8.87468 16.7285 8.76268 16.8405 8.76368 16.9785C8.76368 17.1165 8.87568 17.2285 9.01368 17.2285C9.15168 17.2285 9.26368 17.1165 9.26368 16.9785C9.26368 16.8405 9.15168 16.7285 9.01268 16.7285",
    stroke: "#00C49A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0127 16.7285C13.8747 16.7285 13.7627 16.8405 13.7637 16.9785C13.7637 17.1165 13.8757 17.2285 14.0137 17.2285C14.1517 17.2285 14.2637 17.1165 14.2637 16.9785C14.2637 16.8405 14.1517 16.7285 14.0127 16.7285",
    stroke: "#00C49A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5505_6216",
    x: 0.25,
    y: 1.25,
    width: 27.5,
    height: 28.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5505_6216"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5505_6216",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepscheduleicon);
export default __webpack_public_path__ + "static/media/stepscheduleicon.b99999e9cef0dd529fffa1ac4ae93811.svg";
export { ForwardRef as ReactComponent };